export const filterExcludedAudiences = ({ excludeFromCampaigns }) => excludeFromCampaigns;
